import { render, staticRenderFns } from "./PfoutDetails.vue?vue&type=template&id=65430a4c&scoped=true"
import script from "./PfoutDetails.vue?vue&type=script&lang=js"
export * from "./PfoutDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65430a4c",
  null
  
)

export default component.exports